import {lazy, Suspense} from "react";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import HomepageHeroSection from "@/components/homepage/sections/HomepageHeroSection";
import CountryTextImageSection from "@/components/country/sections/CountryTextImageSection";
import TourCard from "@/components/homepage/cards/TourCard"; // Keep Hero Section rendered above-the-fold


// The heading that introduces the tour grid — "Select Your Mexico Food Tour" in
// the SEO brief. Sized like the other section titles so it reads as one of them.
const ToursHeading = styled.h2`
    font-family: 'Josefin Sans';
    font-weight: bold;
    font-size: 36px;
    text-align: center;
    margin: 40px 0 10px;

    @media only screen and (${breakpoints.mobile}) {
        font-size: 25px;
    }
`;

const ToursDescription = styled.div`
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
`;

const GridWrapper = styled.div`
    margin: 50px 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
        padding: 20px;
    }
`;

export default function CountryPage({ data }) {
    // Destructure `data` to simplify access
    const { reviewOverlay, page, socialLinks, searchOptions } = data?.data || {};
    const { heroImage, textAndImageImage, tours, data: pageData } = page || {};
    const { hero, textAndImage, tours: toursSection } = pageData || {};

    return (
        <>
            {/* Hero Section (Above-the-Fold) */}
            <HomepageHeroSection
                reviewOverlayData={reviewOverlay}
                backgroundImageUrl={heroImage?.url}
                title={hero?.title}
                socialLinks={socialLinks}
                searchOptions={searchOptions}
            />

            {/* Text and Image Section */}
            {(textAndImage?.title || textAndImage?.description) && textAndImageImage && (
                <CountryTextImageSection
                    title={textAndImage?.title}
                    description={textAndImage?.description}
                    image={textAndImageImage}
                />
            )}

            {/* Tours Section */}
            <div className="container">
                <div style={{ padding: "20px" }}>
                    {toursSection?.title && <ToursHeading>{toursSection.title}</ToursHeading>}
                    {toursSection?.description && (
                        <ToursDescription dangerouslySetInnerHTML={{ __html: toursSection.description }} />
                    )}
                    <GridWrapper>
                        {tours?.map((item, index) => (
                            <TourCard item={item} key={index} />
                        ))}
                    </GridWrapper>
                </div>
            </div>
        </>
    );
}
